<form (ngSubmit)="onFormSubmit()" #subBudgetForm="ngForm">
  <mat-form-field>
    <input matInput id="description" placeholder="Description" i18n-placeholder 
    required [(ngModel)]="model.description" name="description">
  </mat-form-field>
  <div class="button-row">
    <button type="submit" mat-raised-button [disabled]="!subBudgetForm.form.valid" i18n>Create budget</button>
  </div>
</form>


// WEBPACK FOOTER //
// ./src/app/budget/components/sub-budget-form.component.html